import { render } from "./ColorPalette.vue?vue&type=template&id=993b5392&scoped=true"
import script from "./ColorPalette.vue?vue&type=script&lang=js"
export * from "./ColorPalette.vue?vue&type=script&lang=js"

import "./ColorPalette.vue?vue&type=style&index=0&id=993b5392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-993b5392"]])

export default __exports__